package com.eladfinish.bible.contest.navigation.back

import androidx.compose.runtime.staticCompositionLocalOf

val LocalBackInterceptorRegistry =
    staticCompositionLocalOf<BackInterceptorRegistry> {
        error("BackInterceptorRegistry not provided")
    }
